import GenericModalContainer from "./GenericModal_container";

export default GenericModalContainer;



// WEBPACK FOOTER //
// ./src/components/GenericModal/index.jsx